document.addEventListener('DOMContentLoaded', function () {
  // DOMが読み込まれたら実行されるコード

  var openButtons = document.querySelectorAll('.js-collection-list-open-button');

  openButtons.forEach(function (openButton) {
    openButton.addEventListener('click', function () {
      // クリックイベントが発生したボタンの親要素を取得
      var wrapper = findAncestor(openButton, 'featured-collections--wrapper');

      // 兄弟要素に is-open クラスが存在するか確認し、toggleできるようにする
      if (wrapper) {
        var featuredCollectionsBody = wrapper.querySelector('.featured-collections--body');
        if (featuredCollectionsBody) {
          featuredCollectionsBody.classList.toggle('is-open');

          // ボタンの子要素のテキストを元に戻す
          var buttonTextElement = openButton.querySelector('div');
          if (buttonTextElement) {
            var buttonText = buttonTextElement.textContent.trim();
            buttonTextElement.textContent = buttonText === '全てのブランドを見る' ? '閉じる' : '全てのブランドを見る';
          }
        }
      }
    });
  });

  // 指定されたクラス名を持つ最も近い祖先要素を返すヘルパー関数
  function findAncestor(element, className) {
    while ((element = element.parentElement) && !element.classList.contains(className));
    return element;
  }
});
